import type { CSSProperties } from 'react';

type CategoryLevelTheme = { color: string; badge?: string; wash: string; selected: string; line: string };

const categoryLevelThemes: CategoryLevelTheme[] = [
  { color: '#155e86', wash: '#edf5fb', selected: '#d6eaf7', line: '#91bad2' },
  { color: '#b33b24', badge: '#c64d34', wash: '#fff3ee', selected: '#fde3d8', line: '#dfaa98' },
  { color: '#356c2b', badge: '#4d813d', wash: '#f3f8ef', selected: '#e3f0df', line: '#a7c797' },
  { color: '#7451a8', wash: '#f7f2fc', selected: '#e9ddf7', line: '#bea6db' },
  { color: '#a93f65', wash: '#fff3f7', selected: '#f8dce7', line: '#dda3ba' },
  { color: '#47772b', wash: '#f3f9ed', selected: '#e1efd0', line: '#aac78d' },
  { color: '#8a5633', wash: '#fbf5ef', selected: '#f0dfcf', line: '#c7a487' },
  { color: '#4c58a5', wash: '#f1f3fc', selected: '#dde2f7', line: '#a8b1dc' },
];

/** Desktop and phone use the same color for each category level. */
export function categoryLevelStyle(depth: number): CSSProperties {
  const hue = Math.round((205 + (depth - 1) * 137.508) % 360);
  const theme: CategoryLevelTheme = categoryLevelThemes[depth - 1] ?? {
    color: `hsl(${hue} 50% 32%)`, wash: `hsl(${hue} 50% 96%)`,
    selected: `hsl(${hue} 55% 89%)`, line: `hsl(${hue} 35% 68%)`,
  };
  return { '--category-color': theme.color, '--category-badge-color': theme.badge ?? theme.color, '--category-wash': theme.wash,
    '--category-selected': theme.selected, '--category-line': theme.line } as CSSProperties;
}
